import React from "react";

import { makeStyles } from "@material-ui/core";
import Box from "@material-ui/core/Box";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Typography from "@material-ui/core/Typography";
import { useHistory, useRouteMatch } from "react-router-dom";

import basicConfig from "./basicConfig";

const useStyles = makeStyles({
  title: {
    display: "block",
    marginTop: 16,
    paddingLeft: 16,
    fontSize: "0.8rem",
    fontWeight: "bold",
    opacity: 0.6,
  },
});

function BasicMenu() {
  const classes = useStyles();
  const history = useHistory();
  const match = useRouteMatch("/examples/basic/:pathParam");
  const pathParam = match?.params?.pathParam;

  return (
    <Box>
      {basicConfig.map(({ group, items }) => (
        <div key={group}>
          <Typography className={classes.title} component="h2">
            {group}
          </Typography>
          <List>
            {items.map(({ path, name }) => (
              <ListItem
                key={path}
                component="li"
                button
                onClick={() => history.push(`/examples/basic/${path}`)}
                selected={pathParam === path}
              >
                <ListItemText primary={name} />
              </ListItem>
            ))}
          </List>
        </div>
      ))}
    </Box>
  );
}

export default React.memo(BasicMenu);
